































import { SpotWidgetDataMixin } from '@/features/core/components/spot-widget-control/data-mixin';
import { ContinuousMetricPoint } from '@/features/core/util/metrics';
import { range } from 'lodash';
import { Component, Mixins } from 'vue-property-decorator';
import bgImage from './heating-control-lg.svg';

interface HeatingMetric {
  index: number;
  name: string;
  point?: ContinuousMetricPoint;
  serial?: string;
  position: number;
}

@Component
export default class HeatingControlDevicePanel extends Mixins(SpotWidgetDataMixin) {
  private get heatingMetrics(): HeatingMetric[] {
    return range(1, 3)
      .map((index) => ({
        index,
        name: `heating${index}`,
        point: this.metrics.continuous[`heating${index}`],
        serial: this.metrics.discrete[`externalProbeSerialNumber${index}`]?.value,
        position:
          this.spot?.metricConfigurations.find(({ name }) => name === `heating${index}`)?.position ?? Number.MAX_VALUE,
      }))
      .sort((a, b) => a.position - b.position || a.index - b.index);
  }

  private backgroundImage = bgImage;
}
